import { Component } from '@angular/core';
import { AuthenticationService } from './../../shared/services/authentication.service';
import { CommunicationService } from './../../shared/services/communication.service';
import * as appConfig from './../../app.config';
import { LoggedUser } from '../../models/shared/loggedUser.model';
import { LocalstorageService } from '../../shared/services/localstorage.service';

@Component({
  selector: 'swb-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  private _sideNavOpen = false;
  public get user(): LoggedUser {
    return LocalstorageService.retrieve(appConfig.authTokenKey);
  }
  public frontUrl: string = appConfig.frontUrl;
  public imgPrefix: string = appConfig.apiUrl + appConfig.mediaFolder + '460x460_';

  constructor(
    private _authService: AuthenticationService,
    private _communicationService: CommunicationService,
    private _storageService: LocalstorageService
  ) { }

  public logout(): void {
    this._authService.logout();
  }

  public toggleSidenav(): void {
    this._sideNavOpen = !this._sideNavOpen;
    this._communicationService.setNavState(this._sideNavOpen);
  }

}
